import { FC, ReactNode } from "react";
import {
  connectRefinementList,
  RefinementListProvided,
} from "react-instantsearch-core";
import { ChevronRightSmall } from "src/icons/ChevronRightSmall";
import { MobileFilterLabel } from "src/molecules/MobileFilterLabel";
import { RightAdornment } from "src/organisms/AlgoliaProductList/MobileFilterView/MobileFilters.styled";
import { FilterItemText } from "./FilterItemText";
import { MessageDescriptor } from "@lingui/core";

interface CustomMenuProps extends RefinementListProvided {
  name: MessageDescriptor;
  icon: ReactNode;
  handleSelectFacet: (name: MessageDescriptor, facet: string) => void;
  setIsOpen: (isOpen: boolean) => void;
  attribute: string;
  keepSelectedIgnoreInActive?: { [p: string]: string[] };
  selectedCatSlug?: string[];
}

const CustomMenu: FC<CustomMenuProps> = ({
  items,
  name,
  attribute,
  icon,
  handleSelectFacet,
  setIsOpen,
  keepSelectedIgnoreInActive,
  selectedCatSlug,
}) => {
  if (!items.length) {
    return null;
  }

  return (
    <MobileFilterLabel
      py={3}
      labelComponent={
        <FilterItemText
          facet={attribute}
          text={name}
          icon={icon}
          keepSelectedIgnoreInActive={keepSelectedIgnoreInActive}
          selectedCatSlug={selectedCatSlug}
        />
      }
      rightAdornment={
        <RightAdornment>
          <ChevronRightSmall />
        </RightAdornment>
      }
      onClick={() => {
        handleSelectFacet(name, attribute);
        setIsOpen(true);
      }}
    />
  );
};

const MenuItem = connectRefinementList(CustomMenu);

export default MenuItem;
